import { useState, useEffect } from "react";

const useFetchProducts = (productId = null) => {
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://inaaniserver-50c4305cc7f7.herokuapp.com/products/getAll");
        if (!res.ok) throw new Error(`Failed to fetch products. Status: ${res.status}`);
        const data = await res.json();

        // Check API error status
        if (data.error) {
          throw new Error(data.message || 'Failed to fetch products');
        }

        const allProducts = data.data || [];

        if (productId !== null) {
          const selectedProduct = allProducts.find((prod) => prod.id === parseInt(productId));
          if (!selectedProduct) throw new Error("Product not found.");
          setProduct(selectedProduct);
        }

        const filtered = allProducts.filter((prod) => prod.id !== parseInt(productId));
        setProducts(filtered);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [productId]);

  return { product, products, loading, error };
};

export default useFetchProducts;
